import * as React from 'react';
import {
  Dialog,
  DialogContent,
  Tab,
  IconButton,
} from '@mui/material';
import { Organisation } from '../types/organisation';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { TabList } from '@mui/lab';
import TabContext from '@mui/lab/TabContext';
import { SocialMediaImporter } from './importer/SocialMediaImporter';
import { MRSSMediaImporter } from './importer/MRSSMediaImporter';

type DialogProps = {
  open: boolean,
  handleClose: () => void,
  organisation: Organisation,
}

const CloseBtnRoot = styled('div')`
    position: absolute;
    right: 8px;
    top: 5px;
    z-index: 2;
`;

const Root = styled('div')`
    position: relative;
`;

export default function OrganisationVideoImporter({
  open,
  handleClose,
  organisation
}: DialogProps) {

  const [activeTab, setActiveTab] = React.useState('0');

  return (<Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth={'lg'}>
    <Root>
      <CloseBtnRoot>
        <IconButton onClick={handleClose}>
          <CloseIcon/>
        </IconButton>
      </CloseBtnRoot>
      <DialogContent sx={{ p: 0 }}>
        <TabContext value={activeTab}>
          <TabList onChange={(_, newValue) => setActiveTab(newValue)}
                   sx={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }}
          >
            <Tab value={'0'} label="Social"/>
            <Tab value={'1'} label="MRSS"/>
          </TabList>
        </TabContext>
        <Box sx={{
          minHeight: '460px',
          margin: 2
        }}>
          { activeTab === '0' && <SocialMediaImporter organisation={organisation}/>}
          { activeTab === '1' && <MRSSMediaImporter organisation={organisation} />}
        </Box>
      </DialogContent>
    </Root>
  </Dialog>);
}

